<template>
  <div class="flex justify-between px-2 py-3">
    <span class="text-sm"> ANPR </span>
    <BaseInputToggle
      :model-value="enabled"
      :disabled="isSaving"
      @update:model-value="handleUpdateModelValue"
    >
      <template #label>
        <HeadlessSwitchLabel
          as="span"
          class="text-primary order-first mr-3 text-sm font-medium"
        >
          {{ enabled ? "ON" : "OFF" }}
        </HeadlessSwitchLabel>
      </template>
    </BaseInputToggle>
  </div>
</template>

<script setup lang="ts">
import { type Camera } from "@/services/cameras/listCameras";
import { setCameraAnpr } from "@/services/cameras/setCameraAnpr";

const props = defineProps<{ camera: Camera }>();

const enabled = ref(props.camera.anprEnabled);
watch(
  () => props.camera.anprEnabled,
  (value) => {
    enabled.value = value;
  },
);

const isSaving = ref(false);

const handleUpdateModelValue = async (value: boolean) => {
  const previous = enabled.value;
  enabled.value = value;
  isSaving.value = true;
  try {
    await setCameraAnpr(props.camera.id, value);
  } catch {
    enabled.value = previous;
    toast.error("Failed to update ANPR");
  } finally {
    isSaving.value = false;
  }
};
</script>
